import Heading from 'components/common/Heading';
import Subheading from 'components/common/Subheading';
import Text from 'components/common/Text';
import ToggleButton from 'components/common/ToggleButton';
import { projectedServings } from 'helpers/servings';
import { FAMILY, HOME_CHEF_MEALS_PER_WEEK } from 'lib/constants';

const FamilyBoxCustomizer = ({
  setWeeklyMeals,
  weeklyMeals,
  servings,
  setServings,
  boxRecommendations,
}) => {
  const servingOptions = Object.entries(projectedServings[FAMILY]).map(([value, display]) => ({
    value: Number(value),
    display,
  }));

  const containerText = {
    header: 'Recommended Box Size',
    subHeader: 'Your recommendation is for the number of lunches and/or dinners we’ll suggest.',
    question: 'Number of Servings Per Recipe',
    subtext: 'Each serving feeds an individual',
    subQuestion: 'Number of Recipes Per Week',
  };

  return (
    <>
      <Heading className="mb-4">{containerText.header}</Heading>
      <Subheading className="text mb-6 text-center">{containerText.subHeader}</Subheading>

      <section>
        <Subheading className="mb-1 max-w-md text-left text-lg font-semibold">
          {containerText.question}
        </Subheading>
        <Text className="textSm mb-4 block text-left">{containerText.subtext}</Text>
        <div className="mb-8 flex flex-row text-center">
          <div
            className="inline-flex flex-wrap gap-2"
            role="radiogroup"
            aria-label="Servings options"
          >
            {servingOptions.map(serving => (
              <ToggleButton
                id={serving.display}
                selected={serving.value === servings}
                handleClick={() => setServings(serving.value)}
                className="relative h-14 w-24 p-1 px-6 bp1:h-14 bp2:w-36"
                type="preference"
                key={serving.display}
                aria-label={`${serving.display} servings${serving.value === boxRecommendations.recommendedServings ? ', BEST FIT' : ''}`}
                role="radio"
              >
                {serving.value === boxRecommendations.recommendedServings && (
                  <span className="h7 absolute bottom-10 left-0 right-0 w-16 rounded-2xl border border-solid border-lemon-100 bg-keto-100 text-charcoal-100 bp1:bottom-10 bp1:left-4 bp1:py-1">
                    BEST FIT
                  </span>
                )}
                {serving.display}
              </ToggleButton>
            ))}
          </div>
        </div>
      </section>

      <section>
        <Subheading className="mb-4 max-w-md text-left text-lg font-semibold">
          {containerText.subQuestion}
        </Subheading>
        <div className="mb-8 flex flex-row text-center">
          <div
            className="inline-flex flex-wrap gap-2"
            role="radiogroup"
            aria-label="Weekly meals options"
          >
            {HOME_CHEF_MEALS_PER_WEEK.map(numberOfMeals => (
              <ToggleButton
                id={numberOfMeals}
                selected={numberOfMeals === weeklyMeals}
                handleClick={() => setWeeklyMeals(numberOfMeals)}
                className="relative h-14 w-24 p-1 px-6 bp1:h-14 bp2:w-36"
                type="preference"
                key={numberOfMeals}
                aria-label={`${numberOfMeals} recipes${numberOfMeals === boxRecommendations.recommendedMeals ? ', BEST FIT' : ''}`}
                role="radio"
              >
                {numberOfMeals === boxRecommendations.recommendedMeals && (
                  <span className="h7 absolute bottom-10 left-0 right-0 w-16 rounded-2xl border border-solid border-lemon-100 bg-keto-100 text-charcoal-100 bp1:left-4 bp1:py-1">
                    BEST FIT
                  </span>
                )}
                {numberOfMeals}
              </ToggleButton>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

FamilyBoxCustomizer.propTypes = {
  weeklyMeals: PropTypes.number.isRequired,
  setWeeklyMeals: PropTypes.func.isRequired,
  servings: PropTypes.number.isRequired,
  setServings: PropTypes.func.isRequired,
  boxRecommendations: PropTypes.object.isRequired,
};

export default FamilyBoxCustomizer;
